export enum InspectionStatusType {
  Pass,
  Rework,
  Reject
}